<template>
  <div class="tables-slot">
    <div class="table-wrapper">
      <table
        class="table table-striped"
        width="100%">
        <thead>
        <tr>
          <slot name="table_head"></slot>
        </tr>
        </thead>
        <tbody>
          <tr v-if="empty_values || empty_spacer">
            <td colspan="100">
              <div class="text-center py-40">
                <b v-if="empty_values">{{empty_values}}</b>
                <span v-if="empty_spacer"></span>
              </div>
            </td>
          </tr>
          <slot name="table_body"></slot>
        </tbody>
      </table>
    </div>
    <pagination
      v-show="!empty_values"
      class="table-wrapper_pagination pr-10"
      @fetch="paginationFetch"
      @popstateEvent="$emit('popstateEvent')"
      :pagination="pagination"
      :additional_fetch_data="additional_fetch_data"
      :fetch_method="fetch_method_post ? 'post' : 'get'"
    />
  </div>
</template>

<script>
import Pagination from "../Pagination";

export default {
  name: "TablesSlot",
  components: {Pagination},
  props: {
    fetch_method_post: {
      type: Boolean,
      default: false
    },
    additional_fetch_data: {
      type: Object,
      default: null
    },
    pagination: {
      type: Array,
      default: []
    },
    empty_values: {
      type: String,
      default: ''
    },
    loader: {
      type: Boolean,
      default: false
    },
    empty_spacer: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    paginationFetch(data) {
      this.$emit('paginationFetch', data)
    }
  },
  mounted() {
  }
}
</script>
